import Cookies from 'js-cookie';
import axios from 'axios';
import qs from 'qs';
import {CustomLinkUrl, CUSTOM_LINK_DATA_COOKIE, SPONSOR_AND_EMPLOYER_COOKIE, GROUP_NAME_COOKIE, RATE_CODE_COOKIE, COMPANY_LOGO_URL_COOKIE} from '../constants';
import {CustomLinkPayload, CustomLinkQueryParameters} from '../types/CustomLinkQueryParameters';
import {captureMessage} from '@sentry/gatsby';

export const fetchCustomLinkData = async (queryParams: CustomLinkQueryParameters) => {
  try {
    const res = await axios.get<CustomLinkPayload>(`${CustomLinkUrl}?${qs.stringify(queryParams)}`);

    return {
      status: 200,
      data: res.data
    };
  } catch (error) {
    captureMessage(`[WJW11] - fetch from Custom Link Service /v1/custom/iwhi error --- ${(error as any).response?.status}`, 'error');
    return {
      status: (error as any).response?.status
    };
  }
};

export const handleCustomLinkCookies = async (customLinkData: CustomLinkPayload, queryParams: CustomLinkQueryParameters, eid?: string, sid?: string) => {
  // Clear potential old cookies
  Cookies.remove(CUSTOM_LINK_DATA_COOKIE);
  Cookies.remove(GROUP_NAME_COOKIE);
  Cookies.remove(RATE_CODE_COOKIE);
  Cookies.remove(SPONSOR_AND_EMPLOYER_COOKIE);
  Cookies.remove(COMPANY_LOGO_URL_COOKIE);

  // Set cookies values from query parameters
  if (sid || eid) {
    Cookies.set(SPONSOR_AND_EMPLOYER_COOKIE, {sid, eid});
  }
  Cookies.set(GROUP_NAME_COOKIE, customLinkData.agentName);
  Cookies.set(RATE_CODE_COOKIE, customLinkData.rateCode && customLinkData.rateCode.trim());
  let frequency = customLinkData.paymentFrequency;
  if (frequency) {
    frequency = frequency.toLocaleLowerCase() === 'half-yearly' ? 'halfyearly' : frequency;
  }
  Cookies.set(CUSTOM_LINK_DATA_COOKIE, {
    Version: 1,
    Source: queryParams.source,
    SourceType: queryParams.type,
    SectionNumber: queryParams.section,
    Group: queryParams.group,
    PaymentFrequency: frequency,
    PaymentMethod: customLinkData.paymentMethod
  });

  const logoUrl = queryParams.corporateLogo ? atob(queryParams.corporateLogo) : '';
  if (logoUrl) Cookies.set(COMPANY_LOGO_URL_COOKIE, logoUrl);
};
